import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-180">
      {/* Background Decorative Elements */}
      <div className="absolute inset-0 z-0 opacity-10 pointer-events-none" data-id="element-181">
        <svg className="absolute top-0 right-0 w-1/2 h-full text-[#2D5A3D]" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-182">
          <path d="M100 0 C 50 0 50 100 0 100 L 100 100 Z" fill="currentColor" data-id="element-183" />
        </svg>
        <svg className="absolute bottom-0 left-0 w-1/3 h-1/2 text-[#C9A96E]" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-184">
          <path d="M0 100 C 50 100 50 0 100 0 L 0 0 Z" fill="currentColor" data-id="element-185" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-186">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-187">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-188">
            <div className="inline-flex items-center space-x-2 bg-[#F5EDE0] px-4 py-2 rounded-full mb-6 border border-[#D4B483]/30" data-id="element-189">
              <Star className="w-4 h-4 text-[#C9A96E] fill-current" data-id="element-190" />
              <span className="text-[#2D5A3D] text-sm font-medium tracking-wide" data-id="element-191">
                EST. 2003 • SINGAPORE
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-[#1A1A1A] leading-tight mb-6" data-id="element-192">
              新加坡历史最悠久的
              <br data-id="element-193" />
              <span className="text-[#2D5A3D]" data-id="element-194">专业按摩推荐平台</span>
            </h1>

            <p className="text-lg md:text-xl text-[#4A4A4A] mb-8 leading-relaxed max-w-lg" data-id="element-195">
              自2003年成立以来，Shiok8一直致力于为您提供最优质、最可靠的按摩服务推荐。让身心在繁忙都市中找到一片宁静绿洲。
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-196">
              <a href="https://www.cfge.me" target="_blank" rel="noopener noreferrer" className="bg-[#C9A96E] hover:bg-[#b89a60] text-white px-8 py-4 rounded-full text-lg font-medium transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 flex items-center justify-center group" data-id="element-197">
                新加坡春风阁
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-198" />
              </a>
              <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="bg-transparent border-2 border-[#2D5A3D] text-[#2D5A3D] hover:bg-[#2D5A3D]/5 px-8 py-4 rounded-full text-lg font-medium transition-all duration-300 flex items-center justify-center" data-id="element-199">
                Telegram Channel
              </a>
            </div>

            <div className="mt-10 flex items-center space-x-4 text-sm text-[#666]" data-id="element-200">
              <div className="flex -space-x-2" data-id="element-201">
                {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full bg-[#D4B483] border-2 border-[#FDF8F0] flex items-center justify-center text-xs text-white font-bold" data-id="element-202">
                    {String.fromCharCode(64 + i)}
                  </div>)}
              </div>
              <p data-id="element-203">
                已有 <span className="font-bold text-[#2D5A3D]" data-id="element-204">50,000+</span>{' '}
                位用户信赖我们
              </p>
            </div>
          </motion.div>

          {/* Hero Image / Visual */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative" data-id="element-205">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/5] md:aspect-square lg:aspect-[4/3]" data-id="element-206">
              {/* Abstract representation of a spa scene using gradients and shapes since we can't use real images reliably */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#2D5A3D] to-[#1A3A25] opacity-90" data-id="element-207"></div>

              {/* Decorative circles mimicking zen stones or water ripples */}
              <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-[#FDF8F0] rounded-full opacity-10 blur-2xl" data-id="element-208"></div>
              <div className="absolute bottom-1/3 right-1/4 w-48 h-48 bg-[#C9A96E] rounded-full opacity-20 blur-3xl" data-id="element-209"></div>

              <div className="absolute inset-0 flex items-center justify-center" data-id="element-210">
                <div className="text-center p-8 border border-[#FDF8F0]/30 rounded-xl backdrop-blur-sm bg-white/5 max-w-xs" data-id="element-211">
                  <h3 className="text-3xl font-serif text-[#FDF8F0] mb-2" data-id="element-212">
                    Shiok8
                  </h3>
                  <p className="text-[#D4B483] tracking-widest uppercase text-sm" data-id="element-213">
                    Premium Wellness
                  </p>
                </div>
              </div>
            </div>

            {/* Floating Badge */}
            <motion.div initial={{
            y: 20,
            opacity: 0
          }} animate={{
            y: 0,
            opacity: 1
          }} transition={{
            delay: 0.6,
            duration: 0.5
          }} className="absolute -bottom-6 -left-6 bg-[#FDF8F0] p-6 rounded-xl shadow-xl border border-[#D4B483]/20 max-w-xs hidden md:block" data-id="element-214">
              <div className="flex items-center gap-4" data-id="element-215">
                <div className="bg-[#2D5A3D]/10 p-3 rounded-full" data-id="element-216">
                  <Star className="w-6 h-6 text-[#2D5A3D] fill-current" data-id="element-217" />
                </div>
                <div data-id="element-218">
                  <p className="text-[#1A1A1A] font-bold text-lg" data-id="element-219">4.9/5.0</p>
                  <p className="text-[#666] text-sm" data-id="element-220">基于 10,000+ 真实评价</p>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}